<global-breadcrumbs
  [dynamicRoute]="{ url: '/dashboard', label: 'dashboard.title' }"
  [alignCenterTitle]="true"
></global-breadcrumbs>
<pac-account-tariffs
  [accountType]="accountType"
  [isToggleAvailable]="isToggleAvailable"
  [availableTariffs]="availableTariffs"
></pac-account-tariffs>